import { getPackageMajorVersion } from "@amzn/aws-console-lotus-web-client-common";

interface PackageEntryScriptElement<PackageExportsT = unknown>
  extends HTMLScriptElement {
  packageExports: PackageExportsT;
  basePath: string;
  versionId: string;
  cspHandlerQueryString?: string;
  telemetryToken?: string;
}

export const getEntryScriptElementId = (
  packageName: string,
  majorVersion: string
): string => {
  return `lotus-entry-script-${getPackageMajorVersion(
    packageName,
    majorVersion
  )}`;
};

export const getEntryScriptElement = <PackageExportsT>(
  ownerDocument: Document,
  packageName: string,
  majorVersion: string
): PackageEntryScriptElement<PackageExportsT> | null => {
  return ownerDocument.getElementById(
    getEntryScriptElementId(packageName, majorVersion)
  ) as PackageEntryScriptElement<PackageExportsT> | null;
};

export const getPackageExports = <PackageExportsT>(
  ownerDocument: Document,
  packageName: string,
  majorVersion: string
): PackageExportsT | undefined => {
  return getEntryScriptElement<PackageExportsT>(
    ownerDocument,
    packageName,
    majorVersion
  )?.packageExports;
};
